<div
    *ngIf="{ isTrial: isTrial$ | async, isEssentialSegment: isEssentialSegment$, isAgency: isAgency$ | async } as $"
    class="a-fx-col a-fx-gap-32"
>
    <div>
        <div *ngIf="$.isTrial && $.isEssentialSegment && !$.isAgency">
            {{ 'common.account-limit.dialog-trial-message' | translate }}
        </div>

        <div *ngIf="(!$.isEssentialSegment || !$.isTrial) && !$.isAgency" class="a-fx-col a-fx-gap-16">
            <div>
                {{ 'common.account-limit.dialog-subscription-message' | translate }}
            </div>

            <div *ngFor="let step of [1, 2, 3]">
                <div class="a-fx a-fx-gap-8">
                    <svg class="adspt-icon check-icon a-color-light-blue a-fx-none">
                        <use xlink:href="#adspt-check"></use>
                    </svg>

                    <div>
                        {{ 'common.account-limit.dialog-subscription-message-step-' + step | translate }}
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="$.isAgency">
            {{ 'common.account-limit.dialog-account-group-message' | translate }}
        </div>
    </div>

    <div class="a-fx a-fx-end-center a-fx-gap-16">
        <nz-select
            *ngIf="$.isAgency"
            class="a-select a-fx-flex"
            adsptHeap="notifications-filter-type"
            [nzLoading]="loading$ | async"
            [nzSuffixIcon]="suffixTemplate"
            [nzCustomTemplate]="accountGroupTmpl"
            ngModel
            [nzPlaceHolder]="'common.account-limit.account-groups' | translate"
            (ngModelChange)="onAccountGroupSelect($event)"
        >
            <nz-option
                *ngFor="let accountGroup of accountGroups$ | async; trackBy: trackByAccountGroup"
                [nzValue]="accountGroup"
                [nzLabel]="accountGroup.name + ' (' + accountGroup.customerId + ')'"
                [nzDisabled]="accountGroup.full"
                [nz-tooltip]="accountGroup.name + ' (' + accountGroup.customerId + ')'"
                nzCustomContent
            >
                <ng-container *ngTemplateOutlet="accountGroupTmpl; context: { $implicit: accountGroup }"></ng-container>
            </nz-option>

            <ng-template #accountGroupTmpl let-accountGroup>
                <div
                    *ngIf="accountGroup.nzValue || accountGroup as accountGroup"
                    class="a-fx-start-center a-fx a-fx-gap-16 a-full-width a-text-overflow-ellipsis"
                >
                    <div class="a-fx-flex a-text-overflow-ellipsis">
                        {{ accountGroup.name }} ({{ accountGroup.customerId }})
                    </div>

                    <nz-tag *ngIf="accountGroup.full" class="a-fx-none a-tag-big adspt-tag-red-line">
                        {{ 'common.account-limit.customer-full' | translate }}
                    </nz-tag>
                </div>
            </ng-template>

            <ng-template #suffixTemplate>
                <i nz-icon style="pointer-events: none">
                    <adspt-icon name="caret-down" />
                </i>
            </ng-template>
        </nz-select>

        <button [class.a-fx-flex]="$.isAgency" nz-button nzType="primary" (click)="onOk($.isAgency)">
            <ng-container *ngIf="!$.isAgency">
                {{ 'common.account-limit.support' | translate }}
            </ng-container>
            <ng-container *ngIf="$.isAgency">
                {{ 'common.account-limit.create-account-group' | translate }}
            </ng-container>
        </button>
    </div>
</div>
